import React from 'react';
import MarkdownField from './MarkdownField';

/**
 * MarkdownEditableCell - EditableCell variant that uses MarkdownField
 * Maintains the same interface as EditableCell but with markdown support
 */
const MarkdownEditableCell = ({
  type = 'text',
  contentType,
  isEditing,
  onBeginEdit,
  value,
  editValue,
  setEditValue,
  saveEdit,
  setEditing,
  placeholder,
  className = '',
  small = false
}) => {
  // Use editValue when editing, value when not editing
  const displayValue = isEditing ? (editValue !== undefined ? editValue : value) : value;
  
  // Handle changes during editing
  const handleChange = (newValue) => {
    setEditValue(newValue);
  };
  
  // Handle save
  const handleSave = () => {
    saveEdit();
  };

  // Handle begin edit
  const handleBeginEdit = () => {
    onBeginEdit();
  };

  // Base style classes
  const baseClassName = `editable-cell ${className}`;
  
  return (
    <div className={baseClassName}>
      <MarkdownField
        type={type === 'textarea' ? 'textarea' : 'input'}
        value={displayValue || ''}
        onChange={handleChange}
        placeholder={placeholder}
        isEditing={isEditing}
        onBeginEdit={handleBeginEdit}
        onEndEdit={handleSave}
        className={`w-full ${small ? 'text-xs' : 'text-sm'} ${
          contentType === 'lyrics' ? "font-['Inconsolata']" : ''
        } px-2 py-1 border-0 focus:outline-none focus:ring-0 placeholder-gray-400 resize-none`}
        rows={type === 'textarea' ? 3 : 1}
      />
    </div>
  );
};

export default MarkdownEditableCell;